import './NoteForm.css'
import FormLabel from '@mui/material/FormLabel';
import Textarea from '@mui/joy/Textarea';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { MuiMarkdown, getOverrides } from 'mui-markdown';
import { useEffect, useState } from 'react';

export function NoteForm({ note, isOpen, onClosed, onSaved }) {
  const [form, setForm] = useState(note);

  const handleChange = (e) => {
    const tmp = {...form}
    tmp[e.target.name] = e.target.value;
    setForm(tmp);
  }

  return (
    <>
      {
        isOpen &&
        note &&
        form &&
        <div>
          <Drawer
            anchor="right"
            open={isOpen}
            onClose={onClosed}
            variant="persistent"
          >
            <div className="padding-base">
              <form className="note-form">
                <div>
                  <div className="text-align-right">
                    <a className="text-neutral-7" onClick={onClosed}><CloseIcon /></a>
                  </div>
                </div>
                <div>
                  <FormLabel>Title</FormLabel>
                  <Textarea 
                    name="title"
                    required 
                    minRows={1} 
                    defaultValue={form.title}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <FormLabel>Details</FormLabel>
                  <Textarea 
                    name="details"
                    minRows={1} 
                    defaultValue={form.details}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <MuiMarkdown>
                    {form.details}
                  </MuiMarkdown>
                </div>
                <div className="display-flex space-between">
                  <Button 
                    variant="contained" 
                    onClick={()=>{onSaved(form)}} 
                    className="full-width">Save</Button>
                </div>
              </form>
            </div>
          </Drawer>
        </div>
      }
    </>
  )
}

export default NoteForm;
